import React, { useState, useEffect } from "react";
import { Box } from '@mui/material';
import ReportToolbar from "../ReportToolbar";
import ReportFooter from "../ReportFooter";
import { ProgramFilter, ReportFilterBar } from "../ReportFilters";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { DataGridPro } from '@mui/x-data-grid-pro';
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../../config";
import dayjs from "dayjs";

const shortcutsItems = [
    {
        label: 'This Week',
        getValue: () => {
            const today = dayjs();
            return [today.startOf('week'), today.endOf('week')];
        },
    },
    {
        label: 'Last Week',
        getValue: () => {
            const today = dayjs();
            const prevWeek = today.subtract(7, 'day');
            return [prevWeek.startOf('week'), prevWeek.endOf('week')];
        },
    },
    {
        label: 'Last 7 Days',
        getValue: () => {
            const today = dayjs();
            return [today.subtract(7, 'day'), today];
        },
    },
    {
        label: 'Current Month',
        getValue: () => {
            const today = dayjs();
            return [today.startOf('month'), today.endOf('month')];
        },
    },
    {
        label: 'Last Month',
        getValue: () => {
            const today = dayjs();
            const lastMonth = today.subtract(1, 'month');
            return [lastMonth.startOf('month'), lastMonth.endOf('month')];
        },
    },
];

export default function IncompleteShiftsReport(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const { startDate, endDate, setStartDate, setEndDate } = props;

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);

        axios
            .get(APIURL + "/reports/getIncompleteShiftsReport", {
                params: {
                    compID: props.user.comp_id,
                    start: moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
                    end: moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
                    program_id: selectedProgram || undefined,
                },
            })
            .then((response) => {
                setData(response?.data.length !== 0 ? response?.data : []);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const rows = data.map((item, idx) => {
        return {
            id: idx,
            schedule_id: item.schedule_id,
            schedule_name: item.schedule_name || '',
            schedule_date: item.date ? moment.utc(item.date).format('MM/DD/YYYY') : '',
            start_time: item.start_time ? moment(item.start_time).format('hh:mm A') : '',
            end_time: item.end_time ? moment(item.end_time).format('hh:mm A') : '',
            task_type: item.task_type || '',
            emp_name: item.emp_first_name ? item.emp_first_name + ' ' + item.emp_last_name : '',
            cus_name: item.cus_name || '',
        };
    });

    const columns = [
        { field: "schedule_name", headerName: "Schedule Name", width: 200 },
        { field: "schedule_date", headerName: "Schedule Date", width: 150 },
        { field: "start_time", headerName: "Start Time", width: 130 },
        { field: "end_time", headerName: "End Time", width: 130 },
        { field: "task_type", headerName: "Type", width: 150 },
        { field: "emp_name", headerName: "Assigned Employee", width: 200 },
        { field: "cus_name", headerName: "Client", width: 200 },
    ];

    const CustomToolbar = () => {
        return (
            <ReportToolbar companyName={props.user.company_name} reportTitle="Incomplete Shifts Report">
                <Box sx={{ pl: 1, pr: 1 }}>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        Date Range: {moment(startDate).format('MM/DD/YYYY')} - {moment(endDate).format('MM/DD/YYYY')}
                    </div>
                </Box>
            </ReportToolbar>
        );
    };

    return (
        <div style={{ width: '100%', padding: 10 }}>
            <div style={{ display: 'flex', marginBottom: 10, justifyContent: 'space-between' }}>
                <ReportFilterBar onSearch={() => fetchData()} style={{ flexWrap: 'wrap', rowGap: 10 }}>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        localeText={{ start: "From Date", end: "To Date" }}
                    >
                        <DateRangePicker
                            label='Date Range'
                            value={[
                                startDate ? dayjs(startDate) : null,
                                endDate ? dayjs(endDate) : null,
                            ]}
                            onChange={(newValue) => {
                                setStartDate(newValue[0] ? new Date(newValue[0]) : null);
                                setEndDate(newValue[1] ? new Date(newValue[1]) : null);
                            }}
                            slotProps={{
                                shortcuts: {
                                    items: shortcutsItems,
                                },
                                textField: { size: 'small', style: { width: 275 } }
                            }}
                        />
                    </LocalizationProvider>

                    <ProgramFilter
                        comp_id={props.user.comp_id}
                        value={selectedProgram}
                        onChange={setSelectedProgram}
                    />
                </ReportFilterBar>
            </div>
            <div style={{ height: 'calc(100vh - 250px)' }}>
                <DataGridPro
                    getRowId={(row) => row.id}
                    rows={rows}
                    columns={columns}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    showToolbar
                    slots={{
                        toolbar: CustomToolbar,
                        footer: ReportFooter
                    }}
                    loading={isLoading}
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            whiteSpace: 'normal',
                            lineHeight: 1.2,
                            textAlign: 'left',
                            wordBreak: 'break-word',
                            maxWidth: '100%',
                        },
                    }}
                />
            </div>
        </div>
    );
}
